export default __webpack_public_path__ + "static/media/HDTX_Pengumuman RUPS LB 2025.4d86beaf.pdf";